<template>
  <z-dialog
    v-model="showSalesReturnPop"
    business
    transparent
    :show-close="false"
    close-on-click-overlay
    :show-confirm-button="false"
  >
    <img
      class="main-img"
      :src="$setPicSize(afterSalesServiceModule.tipBannerPic, 590)"
      @click="showSalesReturnPop = false"
    />
    <div class="close-img" @click="showSalesReturnPop = false">
      <img src="https://pic4.zhuanstatic.com/zhuanzh/314c613c-1a85-4d4c-8069-19b8eaba0fbe.png" />
    </div>
  </z-dialog>
</template>

<script>
import { Dialog } from '@zz-common/zz-ui'
import Vue from 'vue'
import { defineComponent, computed, ref } from '@vue/composition-api'
Vue.use(Dialog)

export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  setup(props) {
    const showSalesReturnPop = ref(false)
    const afterSalesServiceModule = computed(() => {
      const afterSalesServiceModule = props.dataInfo.afterSalesService || {}
      return afterSalesServiceModule
    })

    return { showSalesReturnPop, afterSalesServiceModule }
  }
})
</script>

<style lang="scss" scoped>
.main-img {
  display: block;
  width: 590px;
}
.close-img {
  margin-top: 40px;
  font-size: 0;
  text-align: center;
  img {
    width: 64px;
  }
}
</style>
